import { render } from "./AboutmeTrad.vue?vue&type=template&id=6399c228&scoped=true"
import script from "./AboutmeTrad.vue?vue&type=script&lang=js"
export * from "./AboutmeTrad.vue?vue&type=script&lang=js"

import "./AboutmeTrad.vue?vue&type=style&index=0&id=6399c228&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6399c228"]])

export default __exports__